import React from 'react';

export default function Skills() {
	return (
		<div id='stack'>
			<h2 className='col-12 section-heading'>
            TECH STACK
			</h2>
			<hr className='col-12' />
			<div className='col-12 stacklogos'>
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/javascript.svg' alt='JavaScript' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/html-5.svg' alt='HTML' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/css-3.svg' alt='CSS' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/react.svg' alt='React' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/redux.svg' alt='Redux' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/nodejs.svg' alt='Node' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/express.svg' alt='Express' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/mongodb.svg' alt='MongoDb' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/passport.svg' alt='Passport' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/mocha.svg' alt='Mocha' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/chai.svg' alt='Chai' />
				<img src='https://s3.us-east-2.amazonaws.com/stacklogos/travis-ci.svg' alt='Travis' />
			</div>
		</div>
	);
}